import toast from 'shared/utils/toast';
import { useTranslation } from 'react-i18next';

import { contractsApi } from '../../api/contracts.api';

export const useContractMutations = () => {
  const { t } = useTranslation();

  const onMutationError = () => {
    toast.error(t('actions.error'));
  };

  const addContract = async (payload: unknown) => {
    try {
      return await contractsApi.createContract(payload);
    } catch (error) {
      onMutationError();
      throw error;
    }
  };

  const updateContract = async (contractId: number, payload: unknown) => {
    try {
      return await contractsApi.updateContract(contractId, payload);
    } catch (error) {
      onMutationError();
      throw error;
    }
  };

  const assignContractLine = async (contractId: number, line: unknown) => {
    try {
      return await contractsApi.assignContractLines(contractId, [line]);
    } catch (error) {
      onMutationError();
      throw error;
    }
  };

  const updateContractLine = async (lineId: number, payload: unknown) => {
    try {
      const res = await contractsApi.updateContractLine(lineId, payload);
      toast.success(t('actions.successfully.updated'));
      return res;
    } catch (error) {
      onMutationError();
      throw error;
    }
  };

  const deleteContractLine = async (lineId: number) => {
    try {
      const res = await contractsApi.deleteContractLine(lineId);
      toast.success(t('actions.successfully.deleted'));
      return res;
    } catch (error) {
      onMutationError();
      throw error;
    }
  };

  const addContractEquipment = async (payload: unknown) => {
    try {
      return await contractsApi.addContractEquipment(payload);
    } catch (error) {
      onMutationError();
      throw error;
    }
  };

  const updateContractEquipment = async (id: number, payload: unknown) => {
    try {
      const res = await contractsApi.updateContractEquipment(id, payload);
      toast.success(t('actions.successfully.updated'));
      return res;
    } catch (error) {
      onMutationError();
      throw error;
    }
  };

  const deleteContractEquipment = async (id: number) => {
    try {
      const res = await contractsApi.deleteContractEquipment(id);
      toast.success(t('actions.successfully.deleted'));
      return res;
    } catch (error) {
      onMutationError();
      throw error;
    }
  };

  const addAdditionalCost = async (payload: unknown) => {
    try {
      return await contractsApi.addAdditionalCost(payload);
    } catch (error) {
      onMutationError();
      throw error;
    }
  };

  const deleteAdditionalCost = async (id: number) => {
    try {
      const res = await contractsApi.deleteAdditionalCost(id);
      toast.success(t('actions.successfully.deleted'));
      return res;
    } catch (error) {
      onMutationError();
      throw error;
    }
  };

  const addProductThreshold = async (payload: unknown) => {
    try {
      return await contractsApi.addProductWarehouseThreshold(payload);
    } catch (error) {
      onMutationError();
      throw error;
    }
  };

  return {
    addContract,
    updateContract,
    assignContractLine,
    updateContractLine,
    deleteContractLine,
    addContractEquipment,
    updateContractEquipment,
    deleteContractEquipment,
    addAdditionalCost,
    deleteAdditionalCost,
    addProductThreshold
  };
};
